import { Common } from '../types/Common';

export const common: Common = {
  passwords: [],
  fetchingPasswords: false,
  fetchingPasswordsFailed: false,
  certificates: [],
  fetchingCertificates: false,
  fetchingCertificatesFailed: false,
  licenses: [],
  fetchingLicenses: false,
  fetchingLicensesFailed: false,
  fetchingTenants: false,
  fetchingTenantsFailed: false,
  tenants: []
};
